import { ApiInstance } from '@src/services/api-instance';
import { AutomationsV1Service } from './modules/v1/automations-api-v1';

export class AutomationsApi {
  private readonly client: ApiInstance;

  public v1: AutomationsV1Service;

  constructor(client?: ApiInstance, baseURL?: string) {
    this.client = client || new ApiInstance(`${baseURL ?? import.meta.env.VITE_AUTOMATIONS_BASE_URL}/server`, 30000);

    this.v1 = new AutomationsV1Service(this.client);
  }
}
